/* Copyright (C) NewFoundry 2022 All rights reserved.
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 */
"use strict";

var _classCallCheck = require("/Users/ryanlevin/NewFoundry/Brightsmith/brightsmith-wp/src/plugins/brightsmith-wp-react-app/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Users/ryanlevin/NewFoundry/Brightsmith/brightsmith-wp/src/plugins/brightsmith-wp-react-app/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _inherits = require("/Users/ryanlevin/NewFoundry/Brightsmith/brightsmith-wp/src/plugins/brightsmith-wp-react-app/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var _createSuper = require("/Users/ryanlevin/NewFoundry/Brightsmith/brightsmith-wp/src/plugins/brightsmith-wp-react-app/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createSuper");

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.style = exports.name = exports.mapStateToProps = exports.Category = void 0;

var react_1 = __importDefault(require("react"));

var brightsmith_core_1 = require("brightsmith-core");

var CategoryHelper_1 = __importDefault(require("./helpers/CategoryHelper"));

var DataUtils_1 = __importDefault(require("./utils/DataUtils"));

var BrightsmithDb = brightsmith_core_1.Db.BrightsmithDb;
var name = 'Category';
exports.name = name;

var Category = function Category(components) {
  var Frame = components.Frame,
      Text = components.Text,
      Attribute = components.Attribute,
      styles = components.styles;
  return /*#__PURE__*/function (_react_1$default$Pure) {
    _inherits(_class, _react_1$default$Pure);

    var _super = _createSuper(_class);

    function _class(props) {
      var _this;

      _classCallCheck(this, _class);

      _this = _super.call(this, props);

      if (props.Attribute) {
        Attribute = props.Attribute;
      }

      return _this;
    }

    _createClass(_class, [{
      key: "renderAttributes",
      value: function renderAttributes() {
        var attributeIds = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

        if (!attributeIds.length) {
          return;
        }

        return attributeIds.map(function (attributeId) {
          return react_1.default.createElement(Attribute, {
            key: attributeId,
            attributeId: attributeId
          });
        });
      }
    }, {
      key: "renderCategory",
      value: function renderCategory(category, props) {
        var _this2 = this;

        var _a, _b, _c, _d;

        var after = props.after,
            before = props.before,
            categoryTotal = props.categoryTotal,
            childCategories = props.childCategories,
            classes = props.classes,
            forwardedRef = props.forwardedRef;

        if (!CategoryHelper_1.default.shouldDisplayCategory(category, childCategories)) {
          return react_1.default.createElement(react_1.default.Fragment, null);
        }

        return react_1.default.createElement(Frame, {
          className: ['Category__container', classes === null || classes === void 0 ? void 0 : classes.container],
          ref: forwardedRef,
          style: Object.assign(Object.assign({}, styles === null || styles === void 0 ? void 0 : styles.container), (_a = category === null || category === void 0 ? void 0 : category.style) === null || _a === void 0 ? void 0 : _a.container)
        }, before, ((_b = category.display) === null || _b === void 0 ? void 0 : _b.hideTitle) !== true && react_1.default.createElement(Frame, {
          className: ['Category__inner', classes === null || classes === void 0 ? void 0 : classes.inner],
          style: Object.assign(Object.assign({}, styles === null || styles === void 0 ? void 0 : styles.inner), (_c = category === null || category === void 0 ? void 0 : category.style) === null || _c === void 0 ? void 0 : _c.inner)
        }, react_1.default.createElement(Text, {
          className: ['Category__title', classes === null || classes === void 0 ? void 0 : classes.title],
          style: Object.assign(Object.assign({}, styles === null || styles === void 0 ? void 0 : styles.title), (_d = category === null || category === void 0 ? void 0 : category.style) === null || _d === void 0 ? void 0 : _d.title)
        }, category.name), this.renderPrice(category, categoryTotal, classes)), this.renderAttributes(category.attributes), childCategories && childCategories.map(function (child) {
          return _this2.renderCategory(child, {
            classes: classes,
            category: category
          });
        }), after);
      }
    }, {
      key: "renderPrice",
      value: function renderPrice(category) {
        var categoryTotal = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
        var classes = arguments.length > 2 ? arguments[2] : undefined;

        var _a, _b;

        if (categoryTotal && ((_a = category.display) === null || _a === void 0 ? void 0 : _a.hidePrice) !== false) {
          return react_1.default.createElement(Text, {
            className: ['Category__total', classes === null || classes === void 0 ? void 0 : classes.total],
            style: Object.assign(Object.assign({}, styles === null || styles === void 0 ? void 0 : styles.total), (_b = category === null || category === void 0 ? void 0 : category.style) === null || _b === void 0 ? void 0 : _b.total)
          }, "$", categoryTotal.toLocaleString());
        }

        return react_1.default.createElement(react_1.default.Fragment, null);
      }
    }, {
      key: "render",
      value: function render() {
        var category = this.props.category;
        return this.renderCategory(category, this.props);
      }
    }]);

    return _class;
  }(react_1.default.PureComponent);
};

exports.Category = Category;

var mapStateToProps = function mapStateToProps(state, ownProps) {
  var _a, _b;

  var categoryId = ownProps.categoryId;
  var api = state.api,
      app = state.app;
  var configuration = api.configuration;
  var countryCode = app.countryCode;
  var db = new BrightsmithDb(api);
  var category = db.getCategory(categoryId);
  var categories = db.getCategories();
  var childCategories = DataUtils_1.default.sort(categories.filter(function (c) {
    return c.parentCategory === category.id;
  }));
  category.attributes = DataUtils_1.default.sort((_a = category.attributes) === null || _a === void 0 ? void 0 : _a.map(function (id) {
    return db.getAttribute(id);
  })).map(function (a) {
    return a.id;
  });
  var properties = (_b = category.attributes) === null || _b === void 0 ? void 0 : _b.map(function (attributeId) {
    return db.getProperty(configuration[attributeId], {
      countryCode: countryCode
    });
  });
  var categoryTotal = CategoryHelper_1.default.getCategoryTotal(properties);
  return {
    category: category,
    categoryTotal: categoryTotal,
    childCategories: childCategories
  };
};

exports.mapStateToProps = mapStateToProps;

var style = function style(theme) {
  var _a, _b, _c, _d;

  return {
    container: Object.assign({
      marginBottom: 15
    }, (_a = theme === null || theme === void 0 ? void 0 : theme.Category) === null || _a === void 0 ? void 0 : _a.container),
    inner: Object.assign({
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'space-between',
      marginBottom: 5,
      padding: 10
    }, (_b = theme === null || theme === void 0 ? void 0 : theme.Category) === null || _b === void 0 ? void 0 : _b.inner),
    title: Object.assign({
      color: '#000',
      display: 'flex',
      fontSize: 17,
      fontWeight: '500',
      textTransform: 'uppercase'
    }, (_c = theme === null || theme === void 0 ? void 0 : theme.Category) === null || _c === void 0 ? void 0 : _c.title),
    total: Object.assign({
      color: '#000',
      display: 'flex',
      fontSize: 16,
      marginRight: 7
    }, (_d = theme === null || theme === void 0 ? void 0 : theme.Category) === null || _d === void 0 ? void 0 : _d.total)
  };
};

exports.style = style;